import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import FlightIcon from '@mui/icons-material/Flight';

const solutionData = {
  id: 'aerial-imagery',
  name: 'Aerial & LiDAR Mapping',
  icon: <FlightIcon sx={{ fontSize: 60 }} />,
  description: 'High-resolution aerial imagery and LiDAR data acquisition services',
  overview: `Our Aerial and LiDAR services provide comprehensive aerial mapping solutions using state-of-the-art technology. We capture high-resolution aerial imagery and detailed LiDAR data for various applications including urban planning, infrastructure development, environmental monitoring, and resource management. Our advanced equipment and experienced team ensure the highest quality deliverables tailored to your specific project requirements.`,
  features: [
    {
      title: 'High-Resolution Imagery',
      description: 'Ultra-high resolution digital aerial photography',
    },
    {
      title: 'LiDAR Technology',
      description: 'Advanced LiDAR sensors for detailed 3D point cloud data',
    },
    {
      title: 'Multi-spectral Imaging',
      description: 'Capability to capture data across multiple spectral bands',
    },
    {
      title: 'Precision Navigation',
      description: 'GPS/IMU integration for accurate positioning',
    },
    {
      title: 'Data Processing',
      description: 'Advanced processing workflows for optimal results',
    },
    {
      title: 'Quality Control',
      description: 'Rigorous quality assurance procedures',
    },
  ],
  benefits: [
    'Comprehensive aerial coverage',
    'High accuracy measurements',
    'Rapid data acquisition',
    'Cost-effective mapping solution',
    'Multiple data products',
    'Wide range of applications',
  ],
};

const AerialImagery = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default AerialImagery; 